import { config } from "../../Config";
import React, { useState } from "react";
import "./LoginPopup.css";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import axios from "axios";
import Logo from "./Logo";
import CognexLogo from "./CognexLogo";

const LoginPopup = ({ onSuccess, message }) => {
  const { instance, inProgress } = useMsal();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getUserProfile = async (accessToken) => {
    try {
      const response = await axios.get("https://graph.microsoft.com/v1.0/me", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (e) {
      console.error("Error fetching user profile: ", e);
      throw e;
    }
  };

  const callAddUserApi = async (userId, name, email) => {
    try {
      const response = await axios.post(config.addUser, {
        userid: userId,
        name: name,
        email: email,
      });
      return response;
    } catch (e) {
      if (e.response && e.response.status === 409) {
        return e.response;
      } else {
        throw e;
      }
    }
  };

  const handleSignIn = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const loginResponse = await instance.loginPopup({
        scopes: ["user.read"],
        prompt: "select_account",
      });

      const accessToken = loginResponse.accessToken;

      const userProfile = await getUserProfile(accessToken);

      const userId = userProfile.id;
      const name = userProfile.displayName;
      const email = userProfile.mail || userProfile.userPrincipalName;

      const addUserResponse = await callAddUserApi(userId, name, email);

      // if (addUserResponse.status === 201) {
      //   console.log("User added successfully.");
      // } else if (addUserResponse.status === 409) {
      //   console.log("User already exists. Proceeding with login.");
      // }

      instance.setActiveAccount(loginResponse.account);
      setIsLoading(false);
      onSuccess();
    } catch (e) {
      setError(e);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-popup">
      <div className="login-content">
        <Logo />
        <h2>Welcome to <CognexLogo /></h2>
        <p>Sign in to access your dashboard and personalized features.</p>

        {isLoading ? (
          <p>Loading... Please wait.</p>
        ) : (
          <button
            className="login-button"
            onClick={handleSignIn}
            disabled={inProgress !== InteractionStatus.None}
          >
            Sign In with Microsoft
          </button>
        )}

        {error && (
          <div className="error">
            <p>{error.message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPopup;
